<template>
<div class="test-contact container">
    <div class="row">
        <amf-input label="First Name" v-model="data.firstName" :validator="$v.data.firstName" class="col-6"></amf-input>
        <amf-input label="Last Name" v-model="data.lastName" :validator="$v.data.lastName" class="col-6"></amf-input>
    </div>
</div>
</template>

<script>

export default {
    data() {
        return {
            data: {
                firstName: null,
                lastName: null,
            },
        }
    },
    methods: {
        async save() {
            
        },
    },
    computed: {
        title() { 
            return "Modal 1";
        },
    },
    validations() {
        return {
            data: { 
                firstName: v.build(v.required()),
                lastName: v.build(v.required()),
            }
        }
    }
}

</script>

<style>

</style>


// WEBPACK FOOTER //
// src/tests/TestModal.vue